<template>
  <div>
    <b-form-group
      :label="$t('workflow.nextStages')"
      label-for="input-form-profile-fill"
      class="mb-4"
    >
      <multiselect
        id="input-form-profile-fill"
        v-model="stage.nextStage"
        label="text"
        track-by="value"
        :placeholder="$t('workflow.nextStages')"
        :close-on-select="false"
        :showLabels="false"
        :multiple="true"
        :options="availableStagesOptions"
      >
      </multiselect>
    </b-form-group>
    <b-form-group
      :label="$t('workflow.previousStage')"
      label-for="input-form-profile-fill"
      class="mb-4"
    >
      <multiselect
        id="input-form-profile-fill"
        v-model="previousStagesOptions"
        label="text"
        track-by="value"
        :disabled="true"
        :placeholder="$t('workflow.previousStage')"
        :close-on-select="false"
        :showLabels="false"
        :multiple="true"
        :options="previousStagesOptions"
      >
      </multiselect>
    </b-form-group>

    <stage-crud-card-fields
      :process="process"
      :stage="stage"
      :availableStages="previousStages"
    >
    </stage-crud-card-fields>

    <stage-crud-summary-fields
      :process="process"
      :stage="stage"
      :availableStages="previousStages"
    >
    </stage-crud-summary-fields>

    <!-- <div>stage.nextStage: {{ stage.nextStage }}</div> -->
    <!-- <div>availableStages: {{ availableStages }}</div> -->
    <!-- <div>previousStages: {{ previousStages }}</div> -->
  </div>
</template>
<script>
export default {
  name: "StageCrudNextStages",
  components: {
    StageCrudCardFields: () =>
      import("@/components_rms/workflow/StageCrud/StageCrudCardFields.vue"),
    StageCrudSummaryFields: () =>
      import("@/components_rms/workflow/StageCrud/StageCrudSummaryFields.vue")
  },
  props: {
    process: Object,
    stage: Object,
    availableStages: Array
  },
  mixins: [],
  data() {
    return {};
  },
  computed: {
    availableStagesOptions() {
      let availableStagesOptions = [];
      this.availableStages.forEach(stage => {
        availableStagesOptions.push({
          value: stage.id,
          text: stage.displayName
        });
      });
      return availableStagesOptions;
    },
    nextStages() {
      let nextStages = [];
      for (let stage of this.availableStages) {
        for (let nextStage of this.stage.nextStage) {
          if (nextStage.value == stage.id) {
            nextStages.push(stage);
          }
        }
      }
      return nextStages;
    },
    previousStages() {
      let previousStages = [];
      for (let stage of this.availableStages) {
        for (let nextStage of stage.nextStage) {
          if (nextStage.value == this.stage.id.toString()) {
            previousStages.push(stage);
          }
        }
      }
      return previousStages;
    },
    previousStagesOptions() {
      let previousStages = [];
      this.previousStages.forEach(stage => {
        previousStages.push({
          value: stage.id,
          text: stage.displayName
        });
      });
      return previousStages;
    }
  },
  mounted: function() {},
  methods: {},
  watch: {}
};
</script>
